import React, { useContext, useEffect, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { ViewGoPuffPOCredits } from 'components/gopuff/components/viewGoPuffPOCredits';
import { ViewWholesaleOrders, ViewWholesalePOCredits } from 'components/wholesale/shared';
import { UserContext } from 'contexts/UserContext';
import { TabPanel, WholesaleAccountPicker } from 'shared';

function GoPuffOrderViewer({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };
    const { wholesaleAccount } = useContext(UserContext);

    return (
        <Paper>
            <WholesaleAccountPicker />
            {!!wholesaleAccount.id && (
                <>
                    <Tabs
                        onChange={handleChange}
                        value={selectedTab}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="View Orders" value="0" />
                        <Tab label="View Credits" value="1" />
                    </Tabs>
                    <TabPanel selectedTab={selectedTab} index="0">
                        <ViewWholesaleOrders wholesaleAccount={wholesaleAccount} />
                    </TabPanel>
                    <TabPanel selectedTab={selectedTab} index="1">
                        <ViewWholesalePOCredits wholesaleAccount={wholesaleAccount} />
                    </TabPanel>
                </>
            )}
        </Paper>
    );
}

export { GoPuffOrderViewer };
